import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "me-4" }
const _hoisted_5 = { class: "col-md-12 col-sm-8 mb-3" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "col-md-12 col-sm-8" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { value: null }
const _hoisted_11 = ["label"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "card-toolbar" }
const _hoisted_14 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_15 = { class: "svg-icon svg-icon-2" }
const _hoisted_16 = { class: "card-body pt-0" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "symbol symbol-45px me-5" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_25 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "svg-icon svg-icon-3" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.translate('searchBanners')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-lg form-control-solid",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitFilter && _ctx.onSubmitFilter(...args)), ["enter"])),
                  placeholder: _ctx.translate('searchBanners')
                }, null, 40, _hoisted_7), [
                  [_vModelText, _ctx.search]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.translate('screen')), 1),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-lg form-select-solid",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.screen) = $event))
                }, [
                  _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.translate('all')), 1),
                  _createElementVNode("option", {
                    disabled: "",
                    selected: "",
                    label: _ctx.translate('selectBannerType')
                  }, null, 8, _hoisted_11),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannersAssets.scrrens, (scrren) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: scrren.id,
                      value: scrren.id
                    }, _toDisplayString(scrren.title), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.screen]
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-sm btn-primary mt-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitFilter && _ctx.onSubmitFilter(...args)))
              }, _toDisplayString(_ctx.translate('apply')), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-light me-1 mt-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onResetFilters && _ctx.onResetFilters(...args)))
              }, _toDisplayString(_ctx.translate('reset')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.can('create', 'settings'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goTo('banner-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewBanner')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: banner }) => [
              _createTextVNode(_toDisplayString(banner.id), 1)
            ]),
            "cell-screen": _withCtx(({ row: banner }) => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("img", {
                    alt: "Pic",
                    src: banner.thumbnail
                  }, null, 8, _hoisted_19)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6",
                    onClick: _withModifiers(($event: any) => (_ctx.editBanner(banner.id)), ["prevent"])
                  }, _toDisplayString(banner.screen), 9, _hoisted_21)
                ])
              ])
            ]),
            "cell-typeList": _withCtx(({ row: banner }) => [
              _createTextVNode(_toDisplayString(banner.typeList), 1)
            ]),
            "cell-deeplink": _withCtx(({ row: banner }) => [
              (banner.deeplink)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "badge badge-light-primary",
                    dir: "ltr",
                    title: banner.deeplink
                  }, _toDisplayString(_ctx.deeplinkScreen(banner.deeplink)), 9, _hoisted_22))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, "—"))
            ]),
            "cell-isActive": _withCtx(({ row: banner }) => [
              (banner.isActive)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: banner }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editBanner(banner.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_27, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_26),
              (_ctx.can('remove', 'settings'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusBanner(banner)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_28))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}